const IAP_CUSTOM_FEATURE_NAMES = {
    CA_CERTIFICATES: 'CA_CERTIFICATES',
    DEFAULT_DEVICE_TYPE: 'DEFAULT_DEVICE_TYPE',
};

export default IAP_CUSTOM_FEATURE_NAMES;
